// extracted by mini-css-extract-plugin
export var orderSummary = "_n7-0";
export var showMoreLessButton = "_n7-1";